<template>
    <svg data-v-12f7cbf0="" width="18" height="18" viewBox="0 0 28 35" xmlns="http://www.w3.org/2000/svg" class="video-share-icon video-toolbar-item-icon"><path d="M12.6058 10.3326V5.44359C12.6058 4.64632 13.2718 4 14.0934 4C14.4423 4 14.78 4.11895 15.0476 4.33606L25.3847 12.7221C26.112 13.3121 26.2087 14.3626 25.6007 15.0684C25.5352 15.1443 25.463 15.2144 25.3847 15.2779L15.0476 23.6639C14.4173 24.1753 13.4791 24.094 12.9521 23.4823C12.7283 23.2226 12.6058 22.8949 12.6058 22.5564V18.053C7.59502 18.053 5.37116 19.9116 2.57197 23.5251C2.47607 23.6489 2.00031 23.7769 2.00031 23.2122C2.00031 16.2165 3.90102 10.3326 12.6058 10.3326Z" fill="currentColor"></path></svg>
    <span><slot></slot></span>
</template>

<script>
export default { 
    name: 'blogRoll', 
}
</script>

<style scoped>

</style>